import { postIdServerExternalAuthenticate } from "@/api/token_auth";
import { setToken, setTenantId } from "@/utils/auth";
import { addTokenIntoAxiosHeader } from "@/utils/request";
import { getToken } from "@/utils/auth"; // get token from cookie

const state = {
    authToken: "",
    tenantId: "",
    accessToken: ""
};

const mutations = {
    SET_AUTH_TOKEN: (state, tokenInfo) => {
        console.log("tokenInfo", tokenInfo);
        state.authToken = tokenInfo;
        setToken(tokenInfo);
        addTokenIntoAxiosHeader(tokenInfo.accessToken);
    },
    SET_TENANT_INFO: (state, info) => {
        state.tenantId = info.tenantId;
        setTenantId(info.tenantId);
    },
    SET_ACCESS_TOKEN_ONLY: (state, accessToken) => {
        state.accessToken = accessToken;
    }
};

const actions = {
    async setAccessTokenFromLocalStorage({ commit }) {
        let token = await getToken();
        commit("SET_ACCESS_TOKEN_ONLY", token);
    },
    async setTenantInfo({ commit }, info) {
        console.log("info", info);
        commit("SET_TENANT_INFO", info);
    },
    async setToken({ commit }, token) {
        commit("SET_ACCESS_TOKEN_ONLY", token);
    },
    async getTokenFromCoreAPI({ commit }, info) {
        console.log("info", info);
        var { access_token, expires_at } = info.authInfo;
        var { name, given_name, family_name, email, role, idp, sub } = info.authInfo.profile;
        var { tenantId } = info.tenantInfo;
        var roleName = [];
        roleName[0] = role;

        var tokenInfo = await postIdServerExternalAuthenticate(
            {
                "name": given_name,
                "surname": family_name,
                "username": name,
                "emailAddress": email,
                "roleNames": roleName,
                "authProvider": idp == "local" ? "IdSrvr" : idp,
                "providerKey": sub,
                "providerAccessCode": idp,
                "accessToken": access_token,
                "tokenExpiry": expires_at
            }, 
            {
                "Abp.TenantId": tenantId
            }
        );
        // // console.log('tokenInfo', tokenInfo)
        // setToken(tokenInfo)
        commit("SET_AUTH_TOKEN", tokenInfo);
        return true;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/vuex/modules/auth.js